import React from 'react';

export function WalletColoredIcon({ className, width = 30, height = 30 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 5.25C2.84325 5.25 1.5 6.59325 1.5 8.25V21.75C1.5 23.4067 2.84325 24.75 4.5 24.75H25.5C27.1567 24.75 28.5 23.4067 28.5 21.75V8.25C28.5 8.25 28.5 5.25 25.5 5.25H4.5Z"
        fill="#FFAC33"
      />
      <path d="M1.5 9H28.5V12.75H1.5V9Z" fill="#292F33" />
      <path d="M4.5 15.75H25.5V20.25H4.5V15.75Z" fill="#F4F7F9" />
      <path
        d="M15.7498 19.5C14.4726 19.5 13.9941 18.5925 13.8981 18.1492C13.4878 18.18 13.0881 18.3765 12.5443 18.7222C11.9706 19.0867 11.3203 19.5 10.4998 19.5C9.60206 19.5 9.05681 18.9938 8.99981 18C8.99756 17.958 9.02831 17.859 9.01556 17.859C7.62206 17.859 6.61406 19.1797 6.60431 19.1932C6.45806 19.3935 6.23006 19.5 5.99981 19.5C5.84531 19.5 5.69006 19.4527 5.55656 19.3545C5.22281 19.1092 5.15006 18.6398 5.39531 18.306C5.45306 18.2273 6.83231 16.5 8.99981 16.5C10.4526 16.5 10.5358 17.5313 10.5583 17.916L10.5636 17.9977C10.9281 17.9722 11.3068 17.7323 11.7411 17.4555C12.4618 16.998 13.3558 16.4273 14.5536 16.734C15.2068 16.9013 15.3088 17.5073 15.3478 17.736C15.3576 17.793 15.3718 17.8785 15.3846 17.9055C15.3898 17.9055 15.4941 17.9737 15.8173 18.003C16.4323 18.0592 17.1081 17.7937 17.8236 17.5132C18.5646 17.2222 19.3311 16.9222 20.1568 16.9222C22.6986 16.9222 23.7321 18.1485 23.8416 18.288C24.0966 18.6143 24.0396 19.0853 23.7133 19.3403C23.5821 19.443 23.4276 19.4955 23.2731 19.5C23.0428 19.5068 22.8133 19.4077 22.6603 19.212C22.6423 19.1917 21.9628 18.4215 20.1576 18.4215C19.6153 18.4215 19.0116 18.6578 18.3718 18.9083C17.6151 19.2053 16.5463 19.5 15.7498 19.5Z"
        fill="#8899A6"
      />
    </svg>
  );
}
